import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import isEmpty from '../../validation/is-empty';
import ReactHtmlParser from 'react-html-parser';
import { FormattedMessage, injectIntl } from "react-intl";

class ProductsItem extends Component {
  render() {
    const { product } = this.props;

    function getWords(str) {
      return str.split(/\s+/).slice(0, 20).join(' ');
    }

    return (
      <div className="col-sm-6">
        <div className="property-main">
          <div className="property-wrap">
            <Link to={`/product/${product._id}`}>
              <div className="property-item">
                {isEmpty(product.photo) ? null : (
                  <div
                    className="item-thumb image-center"
                    style={{ backgroundImage: `url(${product.photo})` }}
                  >
                    {isEmpty(product.labelFi) ? null : (
                      <div className="label-inner">
                        <span className="label-status label">
                          {this.props.locale.lang === 'fi'
                            ? product.labelFi
                            : isEmpty(product.labelEn)
                              ? product.labelFi
                              : product.labelEn}
                        </span>
                      </div>
                    )}
                  </div>
                )}

                <div className="item-body products-padding">
                  {isEmpty(product.titleFi) ? null : (
                    <h3 className="property-title">
                      {this.props.locale.lang === 'fi'
                        ? product.titleFi
                        : isEmpty(product.titleEn)
                          ? product.titleFi
                          : product.titleEn}
                    </h3>
                  )}
                  <div className="pricin-list">
                    {isEmpty(product.priceFi) ? (
                      <div className="property-price">
                        <span>
                          <FormattedMessage id="product.free" />
                        </span>
                      </div>
                    ) : (
                        <div className="property-price">
                          <span>
                            {this.props.locale.lang === 'fi'
                              ? product.priceFi
                              : isEmpty(product.priceEn)
                                ? product.priceFi
                                : product.priceEn}
                          </span>
                        </div>
                      )}
                    <p>
                      <div>
                        {ReactHtmlParser(
                          getWords(
                            this.props.locale.lang === 'fi'
                              ? product.descriptionFi
                              : isEmpty(product.descriptionEn)
                                ? product.descriptionFi
                                : product.descriptionEn
                          )
                        )}
                        <p className="learnmore"><FormattedMessage id="product.learnmore" /></p>
                      </div>
                    </p>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

ProductsItem.propTypes = {
  product: PropTypes.object.isRequired,
  locale: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  locale: state.locale,
});

export default connect(mapStateToProps, null)(injectIntl(ProductsItem));
